import React from 'react';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import AppCtaModal from './AppCtaModal';
import styles from './styles/AppCta.module.scss';

import { useWindowSize } from '../Layout/Header';
// Images.
import playBadge from '../../images/google-play-badge.svg';
import appleBadge from '../../images/app-store-badge.svg';

type AppCtaProps = {
  source?: string;
};

const AppCta: React.FunctionComponent<AppCtaProps> = (props: AppCtaProps) => {
  const { source } = props;
  const windowWidth = useWindowSize()[0];
  const [showModal, setShowModal] = React.useState<boolean>(windowWidth < 768);
  const { t } = useTranslation();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isAppReferred = source === 'app' || queryParams.get('source') === 'app';

  React.useEffect(() => {
    if (isAppReferred) {
      setShowModal(false);
      const sourceApp = localStorage.getItem('source');
      if (!sourceApp) {
        localStorage.setItem('source', 'app');
      }
    }
  }, [isAppReferred]);

  return (
    <>
      <AppCtaModal showModal={showModal} setShowModal={setShowModal} />
      {!isAppReferred && (
        <div className={styles.appCta}>
          <h2>{t('landingPage:appCta.title')}</h2>
          <p>{t('landingPage:appCta.description')}</p>
          <p>
            {t('landingPage:appCta.appFrom')} <a href={import.meta.env.VITE_APPLE_LINK}> {t('landingPage:appCta.appleApp')}</a>{' '}
            {t('landingPage:appCta.appFromAlso')} <a href={import.meta.env.VITE_GOOGLE_LINK}> {t('landingPage:appCta.googlePlay')}</a>.
          </p>
          <div className={styles.storeLinks}>
            <a href={import.meta.env.VITE_GOOGLE_LINK}>
              <img className="appBadge" src={playBadge} alt={`${t('landingPage:appCta.downLoadApp')} ${t('landingPage:appCta.googlePlay')}`}></img>
            </a>
            <a href={import.meta.env.VITE_APPLE_LINK}>
              <img className="appBadge" src={appleBadge} alt={`${t('landingPage:appCta.downLoadApp')} ${t('landingPage:appCta.appleApp')}`}></img>
            </a>
          </div>
        </div>
      )}
    </>
  );
};

export default AppCta;
